export default function seatCount(state = 10, action) {
  switch (action.type) {
    case 'SEAT_COUNT_UPDATED':
      return action.seatCount
    default:
      return state
  }
}
